require("packs/bookmarks");
require("packs/filters");
require("packs/home_widget");
import "stylesheets/home.css";
import { initializeBannerSwiper, initializeStaticBannerClicks } from 'shared/banner_utils';

const scrollLeftBtn = document.getElementById("scrollLeftBtn");
const scrollRightBtn = document.getElementById("scrollRightBtn");
const scrollContainer = document.getElementById("horizontalscroll");

function updateScrollButtons() {
  if (!scrollContainer || window.innerWidth < 768) return;
  
  const hasOverflow = scrollContainer.scrollWidth > scrollContainer.clientWidth;
  const atStart = scrollContainer.scrollLeft <= 0;
  const atEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 1;
  const disabledClasses = ["opacity-40", "pointer-events-none"];

  if (scrollLeftBtn) {
    const disabled = !hasOverflow || atStart;
    disabledClasses.forEach(c => scrollLeftBtn.classList.toggle(c, disabled));
  }
  if (scrollRightBtn) {
    const disabled = !hasOverflow || atEnd;
    disabledClasses.forEach(c => scrollRightBtn.classList.toggle(c, disabled));
  }
}

if (scrollLeftBtn && scrollContainer) {
  scrollLeftBtn.addEventListener("click", function () {
    scrollContainer.scrollBy({ left: -100, behavior: "smooth" });
  });
}

if (scrollRightBtn && scrollContainer) {
  scrollRightBtn.addEventListener("click", function () {
    scrollContainer.scrollBy({ left: 100, behavior: "smooth" });
  });
}

if (scrollContainer) {
  scrollContainer.addEventListener("scroll", updateScrollButtons);
  window.addEventListener("resize", updateScrollButtons);
  updateScrollButtons();
}

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.hash) {
    setTimeout(function() {
      var targetElement = document.querySelector(window.location.hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }, 1000);
  }

  // Initialize banner swiper if present
  initializeBannerSwiper('group_page_swiper');
  
  initializeStaticBannerClicks();
});

// Initialize description toggle event delegation
// This function uses event delegation to work with dynamically loaded content
function initializeDescriptionToggleEventDelegation() {
  let toggleDescContent = function (elem, status) {
    if (status == "open") {
      // Find the card container (parent grid element)
      let cardContainer = elem.closest('.card');
      if (cardContainer) {
        // Find the description content within the same card
        let descContent = cardContainer.querySelector('.desc-content');
        if (descContent) {
          // Hide the "Show More" button
          elem.classList.add('hidden');
          // Show the description content
          descContent.classList.remove('hidden');
        }
      }
    } else if (status == "close") {
      // Find the description content container
      let descContent = elem.closest('.desc-content');
      if (descContent) {
        // Find the card container
        let cardContainer = descContent.closest('.card');
        if (cardContainer) {
          // Find and show the "Show More" button again
          let moreInfoButton = cardContainer.querySelector(".desc-open-close");
          if (moreInfoButton) {
            moreInfoButton.classList.remove('hidden');
          }
          // Hide the description content
          descContent.classList.add('hidden');
        }
      }
    }
  };

  // Event delegation for description open buttons
  document.body.addEventListener("click", function(event) {
    const descOpenClose = event.target.closest(".desc-open-close");
    if (descOpenClose) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descOpenClose, "open");
    }
  });

  // Event delegation for description close buttons
  document.body.addEventListener("click", function(event) {
    const descLess = event.target.closest(".desc-less");
    if (descLess) {
      event.preventDefault();
      event.stopPropagation();
      toggleDescContent(descLess, "close");
    }
  });
}

// Initialize the description toggle event delegation
initializeDescriptionToggleEventDelegation();

  // Event listener for share icon click
  let shareIcons = document.querySelectorAll(".shareIcon");
  let closeDiv = document.querySelectorAll(".closediv");
  shareIcons.forEach(function (icon) {
    icon.addEventListener("click", function () {
      let popupMenu = this.nextElementSibling;
      popupMenu.classList.toggle("hidden");
    });
  });
  closeDiv.forEach(function (icon) {
    icon.addEventListener("click", function () {
      let popupMenu = this.parentNode;
      popupMenu.classList.toggle("hidden");
    });
  });


// Open popup
let targetElgroupnotification = document.getElementById(
  "groups_notifications_popup"
);
let optionsgroupnotification = {
  backdrop: "dynamic",
  backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-[700]",
  closable: true,
  onHide: () => {
    const modalContent = document.getElementById("group_modal_content");
    if (modalContent && window.innerWidth < 768) {
      modalContent.classList.add("translate-y-full");
      modalContent.classList.remove("translate-y-0");
    }
    setTimeout(() => location.reload(), 300);
  },
  onShow: () => {
    const modalContent = document.getElementById("group_modal_content");
    if (modalContent && window.innerWidth < 768) {
      setTimeout(() => {
        modalContent.classList.remove("translate-y-full");
        modalContent.classList.add("translate-y-0");
      }, 10);
    }
  },
  onToggle: () => {
  },
};
let instanceOptionsgroupnotification = {
  id: "modalElgroupnotification",
  override: true,
};

let groupnotoficationpop = document.getElementById(
  "groupnotoficationbtn"
);
if (groupnotoficationpop && targetElgroupnotification) {
  groupnotoficationpop.addEventListener("click", function (event) {
    const modal = new Modal(
      targetElgroupnotification,
      optionsgroupnotification,
      instanceOptionsgroupnotification
    );
    modal.show();
  });
}

let closeGroupModalBtn = document.getElementById("close_group_modal");
if (closeGroupModalBtn && targetElgroupnotification) {
  closeGroupModalBtn.addEventListener("click", function (event) {
    const modal = new Modal(
      targetElgroupnotification,
      optionsgroupnotification,
      instanceOptionsgroupnotification
    );
    modal.hide();
  });
}

let getonCloseModalBtn = document.getElementById("geton_Close_Modal");
if (getonCloseModalBtn && targetElgroupnotification) {
  getonCloseModalBtn.addEventListener("click", function (event) {
    const modal = new Modal(
      targetElgroupnotification,
      optionsgroupnotification,
      instanceOptionsgroupnotification
    );
    modal.hide();
  });
}

var openBtn = document.getElementById('owner-container-open');
var closeBtn = document.getElementById('owner-container-close');
var container = document.getElementById('owner-container');

function isClickOutside(target, elements) {
  return !elements.some(el => el.contains(target));
}

if (openBtn && closeBtn && container) {
  openBtn.addEventListener('click', function () {
    slideDownContent(container);
    openBtn.classList.add('hidden');
  });

  closeBtn.addEventListener('click', function () {
    slideUpContent(container);
    openBtn.classList.remove('hidden');
  });

  document.addEventListener('click', function (event) {
    var isVisible = window.getComputedStyle(container).display !== 'none';

    if (isVisible && isClickOutside(event.target, [container, openBtn])) {
      slideUpContent(container);
      openBtn.classList.remove('hidden');
    }
  });
}

function changeCardView(view) {
  let currentUrl = new URL(window.location.href);
  let displayViewParam = "display_view";
  let displayViewValue = view;
  currentUrl.searchParams.set(displayViewParam, displayViewValue);
  window.location.href = currentUrl;
}
document.querySelectorAll(".change-display-view").forEach((display) => {
  display.addEventListener("click", function () {
    changeCardView(this.dataset.view);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("confirmModal");
  const title = document.getElementById("modalTitle");
  const message = document.getElementById("modalMessage");
  const confirmBtn = document.getElementById("confirmActionBtn");

  if (!modal || !title || !message || !confirmBtn) return;

  document.querySelectorAll("[data-action='open-modal']").forEach(btn => {
    btn.addEventListener("click", () => {
      const groupId = btn.dataset.groupId;
      const coOwnerId = btn.dataset.coOwnerId;
      const state = btn.dataset.state;
      const modalTitle = btn.dataset.modalTitle;
      const modalMsg = btn.dataset.modalMessage;
      const confirmText = btn.dataset.buttonText;

      title.textContent = modalTitle;
      message.textContent = modalMsg;
      confirmBtn.textContent = confirmText;

      modal.classList.remove("hidden");

      confirmBtn.onclick = () => {
        const formData = new URLSearchParams();
        formData.append("group_id", groupId);
        formData.append("id", coOwnerId);
        formData.append("state", state);

        fetch(`/groups/${groupId}/group_co_owner_invites/${coOwnerId}`, {
          method: "PUT",
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            "Accept": "text/javascript"
          },
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error("Request failed.");
          return response.text();
        })
        .then(js => {
          closeModal();
          window.location.reload();
        })
        .catch(error => {
          console.error(error);
          alert("Something went wrong.");
        });
      };
    });
  });
});

function closeModal() {
  const modal = document.getElementById("confirmModal");
  if (modal) modal.classList.add("hidden");
}

window.closeModal = closeModal; 

